import IconAdd from "@/assets/images/icon-add circle-filled.svg?react";
import IconDelete from "@/assets/images/icon-delete.svg?react";
import styled from "@emotion/styled";

export const IconAddStyle = styled(IconAdd)`
  & path {
    fill: #3548c9;
  }
`;
export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0px;
`;

export const DeleteButton = styled(IconDelete)<{ isDisable?: boolean }>`
  cursor: ${({ isDisable }) => (isDisable ? "not-allowed" : "pointer")};
  & > path {
    fill: ${({ isDisable }) => (isDisable ? "#C0C9D5" : "#395278")};
  }
`;

export const Title = styled.p`
  margin: 0px;
  font-size: 14px;
  font-weight: 700;
  color: #253858;
`;

export const CampaignChannel = styled.div`
  background: #f4f5f7;
  padding: 24px 16px;
  border-radius: 8px;
  display: grid;
  gap: 20px;
  & .bucket-radio {
    & > label {
      padding: 11px 12px !important;
    }
  }
`;

export const FlexField = styled.div`
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
`;

export const Flex = styled.div`
  display: flex;
  gap: 12px;
  align-items: flex-end;
  & > div {
    width: 100%;
  }
  & .button-add {
    width: fit-content;
    height: 56px;
  }
  & .button-delete {
    width: fit-content;
    height: 56px;
    border: thin solid rgb(235, 69, 83) !important;
    & > svg {
      fill: rgb(235, 69, 83) !important;
    }
  }
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: #c5c8ef;
`;

export const MonthAllocationStyled = styled.div<{ $isTrue: boolean }>`
  width: 100%;
  background: ${({ $isTrue }) => ($isTrue ? "#E8E9F9" : "#E7E9ED")};;
  padding: 16px;
  border-radius: 8px;
  display: grid;
  gap: 16px;
  & > p {
    font-weight: 500;
    font-size: 14px;
    line-height: 140%;
    letter-spacing: -0.2px;
    margin-left: 8px;
  }
`;
export const MonthAllocationSwitchStyled = styled.div`
  display: flex;
  align-items: center;
  & > p {
    font-weight: 500;
    font-size: 14px;
    line-height: 140%;
    letter-spacing: -0.2px;
    margin-left: 8px;
  }
`;
export const MonthAllocationCheckboxStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 16px
`;

